import { FC } from "react";
import ProductReleaseSteps from "./ReleaseSteps";

const PendingReleaseSteps: FC = () => {
  return (
    <div className="py-6  md:py-8   px-4     xl:px-0">
      <p className="headline-sm md:headline-lg">مراحل انتشار آموزش</p>
      <p className="mt-2  mb-3  md:mb-8   body-md md:body-lg">
        آموزش‌هایی که در این مرحله از فرآیند انتشار قرار دارند به طور تقریبی پس
        از ۳ تا ۶ ماه منتشر خواهند شد.
      </p>
      <ProductReleaseSteps />
    </div>
  );
};

export default PendingReleaseSteps;
